'use strict';

export default class ModalManager {
    loadModal(galleryModal) {
        let query = '[data-gallery-modal="' + galleryModal + '"]';
        return document.querySelector(query);
    }

    openModal(modalID, showGalleryList) {
        this.modal = this.loadModal(modalID);
        if (this.modal != null) {
            this.modal.showGalleryList = showGalleryList;
            this.modal.setAttribute('show', 'visible');
        }
    }

    closeModal(modalID) {
        this.modal = this.loadModal(modalID);
        if (this.modal != null) {
            this.modal.setAttribute('show', 'hide');
        }
    }

    setTitle(modalID, title) {
        this.modal = this.loadModal(modalID);
        if (this.modal != null) {
            this.modal.setAttribute('title', title);
        }
    }

    setSubtitle(modalID, subtitle) {
        this.modal = this.loadModal(modalID);
        if (this.modal != null) {
            this.modal.setAttribute('subtitle', subtitle);
        }
    }
}
